// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_AHAfr {
    z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/components/Loading.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd","sourcesContent":[".dialog {\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_AHAfr`
};
export default ___CSS_LOADER_EXPORT___;
